(() => {
  "use strict";

  if (window.__HARDRIP_CHATTY_STABILITY_V20229__) return;
  window.__HARDRIP_CHATTY_STABILITY_V20229__ = true;

  const POPUP = ".Avada-Faqs_Popup";
  const SWIPER = ".Avada-Faqs-Header__Thumbnail--Swiper";
  const OPEN_CLASS = "Avada-Faqs_Popup--Open";
  const CLOSE_CLASS = "Avada-Faqs_Popup--Close";
  const HOME_SEARCH = "button.Avada-Faqs_Search-Article";
  const TRACK_CARD = ".AvadaFaqs-formLayoutFAQ";
  const TRACK_PAGE = "trackTab";
  const INTERACTIVE_TOUCH = [
    "button",
    "a",
    "input",
    "textarea",
    "select",
    "label",
    '[role="button"]',
    '[role="link"]',
    '[contenteditable="true"]'
  ].join(",");
  const OPEN_GUARD_CLASS = "hardrip-chatty-open-v20229";
  const CLOSE_SELECTOR = [
    ".Avada-Faqs_HeaderClose",
    ".Avada-Faqs_HeaderClose-button",
    '[aria-label="Close"]',
    '[aria-label="Chiudi"]',
    '[title="Close"]',
    '[title="Chiudi"]',
    '[class*="HeaderClose"]'
  ].join(",");

  const installStyles = () => {
    if (document.getElementById("hardrip-chatty-v20229-style")) return;
    const style = document.createElement("style");
    style.id = "hardrip-chatty-v20229-style";
    style.textContent = `
      .Avada-Faqs_Popup :is(
        input[placeholder="Cerca aiuto" i],
        input[placeholder="Search for help" i],
        input[placeholder*="help" i]
      ),
      .Avada-Faqs_Popup:not(.homePage)
      :is([class*="Search"], [class*="search"])
      :is(input, textarea, [role="textbox"], [contenteditable="true"], [class*="Input"], [class*="input"]) {
        background: transparent !important;
        background-color: transparent !important;
        background-image: none !important;
        border: 0 !important;
        border-color: transparent !important;
        border-radius: 0 !important;
        outline: 0 !important;
        box-shadow: none !important;
        -webkit-box-shadow: none !important;
        appearance: none !important;
        -webkit-appearance: none !important;
      }

      @keyframes hardripChattyCloseV20229 {
        from {
          opacity: 1;
          transform: translate3d(0, var(--hardrip-chatty-drag-y, 0px), 0);
        }
        to {
          opacity: 1;
          transform: translate3d(0, 100dvh, 0);
        }
      }

      html.${OPEN_GUARD_CLASS} #Avada-FAQ_Widget {
        position: relative !important;
        z-index: 2147483000 !important;
      }

      html.${OPEN_GUARD_CLASS} .Avada-Faqs_Popup.Avada-Faqs_Popup--Open {
        z-index: 2147483001 !important;
      }

      /* Ecomsend/Trustoo can leave a full-screen modal container above Chatty
         even when its dialog is visually absent. While Chatty is open, that
         layer must never steal Back / Close / FAQ taps. It becomes interactive
         again immediately when Chatty closes. */
      html.${OPEN_GUARD_CLASS} #ecomsend-widget :is(
        [data-testid="modal-container"],
        .react-responsive-modal-overlay,
        .react-responsive-modal-container
      ) {
        pointer-events: none !important;
      }

      @media (max-width: 500px) {
        .Avada-Faqs_Popup.mobile.Avada-Faqs_Popup--Close {
          /* Chatty removes the closing popup after 200 ms; finish one frame
             earlier so iOS paints the final off-screen position first. */
          animation: hardripChattyCloseV20229 180ms cubic-bezier(.4, 0, 1, 1) both !important;
          transform-origin: center bottom !important;
          opacity: 1 !important;
        }

        .Avada-Faqs_Popup.mobile[data-hardrip-chatty-dragging="true"] {
          animation: none !important;
          transition: none !important;
          transform: translate3d(0, var(--hardrip-chatty-drag-y, 0px), 0) !important;
          opacity: 1 !important;
          will-change: transform;
        }

        .Avada-Faqs_Popup.mobile[data-hardrip-chatty-swipe-closing="true"]:not(.Avada-Faqs_Popup--Close) {
          animation: none !important;
          transition: none !important;
          transform: translate3d(0, var(--hardrip-chatty-drag-y, 0px), 0) !important;
          opacity: 1 !important;
        }

        .Avada-Faqs_Popup.mobile[data-hardrip-chatty-snapback="true"] {
          animation: none !important;
          transition: transform 220ms cubic-bezier(.22, 1, .36, 1) !important;
          transform: translate3d(0, 0, 0) !important;
          opacity: 1 !important;
          will-change: transform;
        }

        .Avada-Faqs_Popup.mobile ${SWIPER} {
          touch-action: none;
        }
      }
    `;
    (document.head || document.documentElement).appendChild(style);
  };

  let popup = null;
  let popupObserver = null;
  let bodyObserver = null;
  let settleTimer = 0;
  let resetToken = 0;
  let resetAttempts = 0;
  let homeResetPending = false;
  let homeResetStartedAt = 0;
  let trackRecoveryTimer = 0;
  let openingWatchTimer = 0;
  let openingWatchArmed = false;
  let openingRescueCount = 0;
  let openingFallbackInserted = false;
  let navigationCommitted = false;
  let blankNavigationTimer = 0;
  let emergencyTimer = 0;
  let popupSession = 0;
  let swipeNode = null;
  let swipeCleanup = null;

  const clearSettleTimer = () => {
    if (settleTimer) window.clearTimeout(settleTimer);
    settleTimer = 0;
  };

  const clearTrackRecoveryTimer = () => {
    if (trackRecoveryTimer) window.clearTimeout(trackRecoveryTimer);
    trackRecoveryTimer = 0;
  };

  const clearOpeningWatch = () => {
    if (openingWatchTimer) window.clearTimeout(openingWatchTimer);
    openingWatchTimer = 0;
    openingWatchArmed = false;
  };

  const clearBlankNavigationTimer = () => {
    if (blankNavigationTimer) window.clearTimeout(blankNavigationTimer);
    blankNavigationTimer = 0;
  };

  const clearEmergencyTimer = () => {
    if (emergencyTimer) window.clearTimeout(emergencyTimer);
    emergencyTimer = 0;
  };

  /* Safari can retain invisible React content while presenting an entirely
     black HELP panel. Loaded means painted and reachable, not merely present
     as text in the DOM. */
  const isPainted = (node) => {
    if (!(node instanceof Element)) return false;
    const rect = node.getBoundingClientRect();
    if (rect.width < 5 || rect.height < 5) return false;
    for (let current = node; current instanceof Element; current = current.parentElement) {
      const css = window.getComputedStyle(current);
      if (css.display === "none" || css.visibility === "hidden" ||
          Number(css.opacity) < 0.02) return false;
      if (current === popup) break;
    }
    return true;
  };

  /* Only a real, trusted launcher gesture begins a fresh recovery budget.
     Synthetic close/reopen during recovery cannot loop indefinitely. */
  const onLauncherIntent = (event) => {
    if (!event.isTrusted || !(event.target instanceof Element)) return;
    if (!event.target.closest("#Avada-FAQ_WidgetTrigger")) return;
    if (isOpen(popup)) return;
    openingRescueCount = 0;
    navigationCommitted = false;
  };

  const setOpenGuard = (open) => {
    document.documentElement.classList.toggle(OPEN_GUARD_CLASS, Boolean(open));
  };

  const isOpen = (element) =>
    element instanceof Element &&
    element.isConnected &&
    element.classList.contains(OPEN_CLASS) &&
    !element.classList.contains(CLOSE_CLASS);

  const isHome = (element) =>
    element instanceof Element &&
    (String(element.getAttribute("data-chatty-page") || "").toLowerCase() === "homepage" ||
      element.classList.contains("homePage") ||
      Boolean(element.querySelector(HOME_SEARCH)));

  const isTrackingCard = (element) => {
    if (!(element instanceof Element)) return false;
    const card = element.closest(TRACK_CARD);
    if (!(card instanceof Element) || !popup?.contains(card)) return false;
    const title = card.querySelector(".Avada-Faqs_SectionPrimary_TitleBlock");
    if (!(title instanceof Element)) return false;
    const label = `${title.getAttribute("aria-label") || ""} ${title.textContent || ""}`
      .replace(/\s+/g, " ")
      .trim();
    return /^(?:tracciamento dell['’]ordine|order tracking|track your order)(?:\s|$)/i.test(label);
  };

  /* Chatty sometimes restores a stale Help tab before its React body mounts.
     Inspect real content, not the header, so a purple Help header over a black
     empty sheet is never mistaken for a successfully loaded FAQ page. */
  const hasLoadedContent = (element) => {
    if (!(element instanceof Element)) return false;
    const route = element.getAttribute("data-chatty-page") || "";
    const body = element.querySelector(".Avada-Faqs_BodyDocument");
    if (!(body instanceof Element) || !isPainted(body)) return false;
    if (route === "homePage") {
      const cards = [...body.querySelectorAll(".AvadaFaqs-formLayoutFAQ, .Avada-List-Item, button.Avada-Faqs_Search-Article")];
      return cards.some(el => isPainted(el)) || ((body.innerText || "").trim().length > 75 && isPainted(body));
    }
    if (route === "categoriesList" || route === "categoryDetail") {
      return [...body.querySelectorAll(".Avada-List-Item")].some(el => isPainted(el) && (el.innerText || "").trim());
    }
    if (route === "questionDetail") {
      return isPainted(body) && (body.innerText || "").trim().length > 20;
    }
    if (route === TRACK_PAGE) {
      return [...body.querySelectorAll("input,form,iframe,button,a")].some(el => isPainted(el));
    }
    return isPainted(body) && (body.innerText || "").trim().length > 40;
  };

  const clearHelpRecovery = () => {
    popup?.querySelector(".hardrip-chatty-help-recovery")?.remove();
    openingFallbackInserted = false;
  };

  /* If Chatty's React body never mounts, a fallback attached only inside
     .Avada-Faqs_BodyDocument is invisible. Mount under the popup instead. */
  const showHelpRecovery = (forceHome = false) => {
    if (!isOpen(popup) || (!forceHome && hasLoadedContent(popup))) return;
    if (popup.querySelector(".hardrip-chatty-help-recovery")) return;
    const fallback = document.createElement("section");
    fallback.className = "hardrip-chatty-help-recovery";
    fallback.setAttribute("role", "status");
    fallback.style.cssText = "position:absolute;top:130px;left:14px;right:14px;max-height:calc(100% - 148px);overflow-y:auto;z-index:2147483003;padding:22px 18px;background:#121216;border:1px solid #5f3c96;border-radius:14px;box-shadow:0 14px 36px #0008;color:#f8f7fa;font:inherit;box-sizing:border-box;";
    const controls = forceHome && !navigationCommitted
      ? '<h2 style="font-size:20px;line-height:1.35;margin:0 0 9px;color:#f8f7fa">Ciao 👋 Come possiamo aiutarti?</h2><p style="margin:0 0 20px;color:#bfa9de">Scegli come possiamo aiutarti</p><a href="/tools/tracking" style="display:block;padding:14px 16px;background:#5f3c96;color:#fff;border-radius:9px;text-decoration:none;margin-bottom:12px">Tracciamento dell’ordine</a><a href="/pages/faqs" style="display:block;padding:14px 16px;border:1px solid #bfa9de;color:#fff;border-radius:9px;text-decoration:none;margin-bottom:20px">Domande frequenti</a>'
      : '<h2 style="font-size:17px;line-height:1.4;margin:0 0 18px;color:#f8f7fa">Il contenuto di AIUTO non si è caricato</h2><a href="/pages/faqs" style="display:block;padding:12px 16px;margin-bottom:14px;border:1px solid #bfa9de;border-radius:9px;color:#fff;text-decoration:none">Apri le FAQ</a>';
    fallback.innerHTML = controls +
      '<button type="button" data-hardrip-chatty-retry style="padding:12px 16px;background:#5f3c96;color:#fff;border:0;border-radius:9px;font:inherit;cursor:pointer">Riprova</button>';
    fallback.querySelector('[data-hardrip-chatty-retry]').addEventListener("click", () => {
      openingRescueCount = 0;
      navigationCommitted = false;
      clearHelpRecovery();
      restartStuckChatty();
    });

    popup.appendChild(fallback);
    openingFallbackInserted = true;
    clearOpeningWatch();
    finishHomeReset();
    clearEmergencyTimer();
  };

  /* This watch is independent of Chatty's React mutation sequence.
     A dead panel can never stay completely black because the fallback is
     rendered at the visible root, not inside an unmounted/hidden body. */
  const watchVisibleOpening = () => {
    if (!isOpen(popup) || emergencyTimer || popup.querySelector(".hardrip-chatty-help-recovery")) return;
    const token = popupSession;
    const route = popup.getAttribute("data-chatty-page") || "";
    const delay = route === "homePage" ? 5700 : 3000;
    emergencyTimer = window.setTimeout(() => {
      emergencyTimer = 0;
      if (token !== popupSession || !isOpen(popup) || navigationCommitted) return;
      if (isHome(popup) && hasLoadedContent(popup)) return;
      const currentRoute = popup.getAttribute("data-chatty-page") || "";
      if (currentRoute !== route && hasLoadedContent(popup)) return;
      if (currentRoute !== "homePage") {
        const back = popup.querySelector(".Avada-Faqs_HeaderBack");
        if (back instanceof HTMLElement && resetAttempts < 6) {
          resetAttempts += 1;
          back.click();
          watchVisibleOpening();
        } else {
          showHelpRecovery(true);
        }
      } else {
        showHelpRecovery(true);
      }
    }, delay);
  };

  /* Preserve user-selected Help/FAQ/article routes; only display recovery
     for empty pages. Never send an intentional navigation back to Home. */
  const scheduleBlankNavigationRecovery = () => {
    if (blankNavigationTimer || !navigationCommitted || !isOpen(popup) || hasLoadedContent(popup)) return;
    const routeAtStart = popup.getAttribute("data-chatty-page") || "";
    blankNavigationTimer = window.setTimeout(() => {
      blankNavigationTimer = 0;
      if (!isOpen(popup) || !navigationCommitted || hasLoadedContent(popup)) return;
      if ((popup.getAttribute("data-chatty-page") || "") !== routeAtStart) return;
      showHelpRecovery();
    }, 6500);
  };

  const restartStuckChatty = () => {
    if (!isOpen(popup)) return;
    clearOpeningWatch();
    finishHomeReset();
    clearBlankNavigationTimer();
    clearEmergencyTimer();
    clearHelpRecovery();
    const trigger = document.getElementById("Avada-FAQ_WidgetTrigger");
    const close = popup.querySelector(".Avada-Faqs_HeaderClose");
    if (close instanceof HTMLElement) close.click();
    else trigger?.click();
    window.setTimeout(() => {
      if (!trigger?.isConnected) return;
      if (trigger.getAttribute("aria-expanded") !== "true") trigger.click();
    }, 560);
  };

  const watchStuckOpening = () => {
    if (!openingWatchArmed || openingWatchTimer || !isOpen(popup)) return;
    const generation = resetToken;
    openingWatchTimer = window.setTimeout(() => {
      openingWatchTimer = 0;
      if (!openingWatchArmed || generation !== resetToken || !isOpen(popup)) return;
      openingWatchArmed = false;
      if (hasLoadedContent(popup) || navigationCommitted) return;
      /* Do not automatically close and reopen a slowly mounting iOS widget:
         this caused the native state to reopen on stale HELP routes. */
      showHelpRecovery(true);
    }, 5400);
  };

  const goToRealTracking = () => {
    homeResetPending = false;
    resetAttempts = 0;
    clearSettleTimer();
    clearTrackRecoveryTimer();
    window.location.assign("/tools/tracking");
  };

  const interceptTrackingNavigation = (event) => {
    if (!isOpen(popup) || !isHome(popup)) return;
    if (!(event.target instanceof Element) || !isTrackingCard(event.target)) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    goToRealTracking();
  };

  const interceptTrackingKeyboard = (event) => {
    if (event.key !== "Enter" && event.key !== " ") return;
    if (!isOpen(popup) || !isHome(popup)) return;
    if (!(event.target instanceof Element) || !isTrackingCard(event.target)) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    goToRealTracking();
  };

  const scheduleBrokenTrackRecovery = () => {
    clearTrackRecoveryTimer();
    if (!isOpen(popup) || homeResetPending || popup.getAttribute("data-chatty-page") !== TRACK_PAGE) return;
    trackRecoveryTimer = window.setTimeout(() => {
      trackRecoveryTimer = 0;
      if (!isOpen(popup) || homeResetPending || popup.getAttribute("data-chatty-page") !== TRACK_PAGE) return;
      const body = popup.querySelector(".Avada-Faqs_BodyDocument");
      const meaningful = body && (
        body.children.length > 0 ||
        (body.textContent || "").trim().length > 0 ||
        body.querySelector("input,form,iframe,button,a")
      );
      if (!meaningful) goToRealTracking();
    }, 650);
  };

  const findBackButton = (element) => {
    if (!(element instanceof Element)) return null;
    for (const button of element.querySelectorAll('button,[role="button"]')) {
      if (button.matches(CLOSE_SELECTOR)) continue;
      const label = `${button.getAttribute("aria-label") || ""} ${button.getAttribute("title") || ""} ${button.textContent || ""}`;
      if (/indietro|back|torna|home/i.test(label) && !/close|chiudi/i.test(label)) return button;
    }
    return null;
  };

  const finishHomeReset = () => {
    homeResetPending = false;
    resetAttempts = 0;
    clearSettleTimer();
  };

  /* A real tap inside Chatty means that the user owns navigation from this
     point on. The opener recovery must never undo a deliberately opened FAQ. */
  const cancelHomeResetOnIntent = (event) => {
    if (!event.isTrusted || !(event.target instanceof Element)) return;
    if (!popup?.contains(event.target)) return;
    /* The first real user gesture takes ownership of the open popup,
       regardless of whether the opener reset was still active. */
    navigationCommitted = true;
    finishHomeReset();
    clearOpeningWatch();
  };

  const runHomeResetAttempt = (token) => {
    settleTimer = 0;
    if (token !== resetToken || !homeResetPending || !isOpen(popup)) return;
    if (isHome(popup)) {
      finishHomeReset();
      return;
    }
    if (performance.now() - homeResetStartedAt > 7900 || resetAttempts >= 6) {
      finishHomeReset();
      if (!isHome(popup) && !navigationCommitted) {
        showHelpRecovery(true);
      }
      return;
    }
    if (popup.hasAttribute("data-hardrip-chatty-dragging")) {
      scheduleHomeResetAttempt(150);
      return;
    }

    /* The initial render may take seconds on iOS. Do not press Back while
       Chatty is mounting, and never navigate merely because Home is not yet
       in the DOM. Only a real stale route from a previous session qualifies. */
    const route = popup.getAttribute("data-chatty-page") || "";
    if (!route || route === "homePage") {
      scheduleHomeResetAttempt(350);
      return;
    }

    const back = popup.querySelector(".Avada-Faqs_HeaderBack");
    if (!(back instanceof HTMLElement)) {
      scheduleHomeResetAttempt(350);
      return;
    }

    /* One native Back per settled render, at most three times, exclusively
       during this freshly reopened popup. User interaction cancels immediately. */
    resetAttempts += 1;
    back.click();
    scheduleHomeResetAttempt(360);
  };

  function scheduleHomeResetAttempt(delay = 260) {
    if (!homeResetPending || settleTimer) return;
    const token = resetToken;
    settleTimer = window.setTimeout(() => runHomeResetAttempt(token), delay);
  }

  const resetMotionState = (element) => {
    if (!(element instanceof Element)) return;
    element.removeAttribute("data-hardrip-chatty-dragging");
    element.removeAttribute("data-hardrip-chatty-snapback");
    element.removeAttribute("data-hardrip-chatty-swipe-closing");
    element.style.removeProperty("--hardrip-chatty-drag-y");
    // Remove only residue written by Chatty's broken native swipe routine.
    element.style.removeProperty("max-height");
    element.style.removeProperty("display");
  };

  const wireSwipe = () => {
    if (!(popup instanceof Element) || !popup.isConnected) return;
    const node = popup.querySelector(SWIPER);
    if (!(node instanceof Element) || node === swipeNode) return;

    swipeCleanup?.();
    swipeNode = node;

    let active = false;
    let dragging = false;
    let startY = 0;
    let currentY = 0;
    let startTime = 0;
    let lastY = 0;
    let lastTime = 0;

    const stopNativeSwipe = (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
    };

    const onTouchStart = (event) => {
      if (!(event.target instanceof Element) || !event.target.closest(SWIPER)) return;
      if (!isOpen(popup) || event.touches.length !== 1) return;
      /* Never convert a real control tap into a drag gesture. */
      if (event.target.closest(INTERACTIVE_TOUCH)) return;
      stopNativeSwipe(event);
      const y = event.touches[0].clientY;
      active = true;
      dragging = false;
      startY = y;
      currentY = y;
      lastY = y;
      startTime = event.timeStamp;
      lastTime = event.timeStamp;
      popup.removeAttribute("data-hardrip-chatty-snapback");
      popup.removeAttribute("data-hardrip-chatty-swipe-closing");
      popup.style.removeProperty("max-height");
      popup.style.removeProperty("display");
    };

    const onTouchMove = (event) => {
      if (!(event.target instanceof Element) || !event.target.closest(SWIPER)) return;
      if (!active || event.touches.length !== 1) return;
      stopNativeSwipe(event);
      const y = event.touches[0].clientY;
      if (y >= currentY || event.timeStamp - lastTime > 80) {
        lastY = currentY;
        lastTime = event.timeStamp;
      }
      currentY = Math.max(startY, y);
      const distance = currentY - startY;
      if (!dragging && distance >= 4) {
        dragging = true;
        clearSettleTimer();
        popup.setAttribute("data-hardrip-chatty-dragging", "true");
      }
      if (dragging) {
        // A single compositor-only transform write makes the sheet follow the
        // finger; no layout property is read or changed during touchmove.
        popup.style.setProperty("--hardrip-chatty-drag-y", `${distance}px`);
      }
    };

    const finishTouch = (event) => {
      if (!(event.target instanceof Element) || !event.target.closest(SWIPER)) return;
      if (!active) return;
      stopNativeSwipe(event);
      const endY = event.changedTouches?.[0]?.clientY ?? currentY;
      currentY = Math.max(startY, endY);
      const distance = currentY - startY;
      popup.style.setProperty("--hardrip-chatty-drag-y", `${distance}px`);

      const recentDuration = Math.max(1, event.timeStamp - lastTime);
      const recentVelocity = Math.max(0, currentY - lastY) / recentDuration;
      const totalVelocity = distance / Math.max(1, event.timeStamp - startTime);
      const threshold = Math.min(170, popup.getBoundingClientRect().height * 0.2);
      const shouldClose = dragging && (distance >= threshold || (distance >= 48 && Math.max(recentVelocity, totalVelocity) >= 0.55));

      active = false;
      popup.removeAttribute("data-hardrip-chatty-dragging");

      if (shouldClose) {
        popup.setAttribute("data-hardrip-chatty-swipe-closing", "true");
        const close = popup.querySelector(CLOSE_SELECTOR);
        if (close instanceof HTMLElement) close.click();
        else document.getElementById("Avada-FAQ_WidgetTrigger")?.click();
      } else if (dragging) {
        popup.setAttribute("data-hardrip-chatty-snapback", "true");
        window.setTimeout(() => {
          if (!popup || popup.classList.contains(CLOSE_CLASS)) return;
          popup.removeAttribute("data-hardrip-chatty-snapback");
          popup.style.removeProperty("--hardrip-chatty-drag-y");
        }, 240);
      }

      dragging = false;
    };

    const options = { capture: true, passive: false };
    // Capture on the popup ancestor so Chatty's target-level max-height/display
    // handlers never receive a swipe that started on its header drag handle.
    popup.addEventListener("touchstart", onTouchStart, options);
    popup.addEventListener("touchmove", onTouchMove, options);
    popup.addEventListener("touchend", finishTouch, options);
    popup.addEventListener("touchcancel", finishTouch, options);

    swipeCleanup = () => {
      popup?.removeEventListener("touchstart", onTouchStart, options);
      popup?.removeEventListener("touchmove", onTouchMove, options);
      popup?.removeEventListener("touchend", finishTouch, options);
      popup?.removeEventListener("touchcancel", finishTouch, options);
      if (swipeNode === node) swipeNode = null;
    };
  };

  const disconnectPopup = () => {
    clearOpeningWatch();
    clearBlankNavigationTimer();
    clearEmergencyTimer();
    setOpenGuard(false);
    clearTrackRecoveryTimer();
    popupObserver?.disconnect();
    popupObserver = null;
    swipeCleanup?.();
    swipeCleanup = null;
    popup = null;
    clearSettleTimer();
  };

  const wirePopup = (candidate) => {
    if (!(candidate instanceof Element) || candidate === popup) return;
    disconnectPopup();
    popup = candidate;
    let wasOpen = isOpen(popup);
    let lastObservedRoute = popup.getAttribute("data-chatty-page") || "";
    let homeContentReady = wasOpen && isHome(popup) && hasLoadedContent(popup);
    setOpenGuard(wasOpen);
    if (wasOpen) resetMotionState(popup);
    wireSwipe();

    popupObserver = new MutationObserver((mutations) => {
      if (!popup?.isConnected) {
        disconnectPopup();
        return;
      }

      wireSwipe();
      const open = isOpen(popup);
      setOpenGuard(open);
      if (open && hasLoadedContent(popup) && (isHome(popup) || navigationCommitted)) clearHelpRecovery();
      if (!open) {
        wasOpen = false;
        popupSession += 1;
        clearEmergencyTimer();
        homeContentReady = false;
        lastObservedRoute = popup.getAttribute("data-chatty-page") || "";
        clearOpeningWatch();
        clearBlankNavigationTimer();
        clearHelpRecovery();
        clearTrackRecoveryTimer();
        resetToken += 1;
        homeResetPending = false;
        resetAttempts = 0;
        clearSettleTimer();
        return;
      }

      if (!wasOpen) {
        wasOpen = true;
        resetToken += 1;
        resetAttempts = 0;
        resetMotionState(popup);
        clearBlankNavigationTimer();
        clearEmergencyTimer();
        popupSession += 1;
        lastObservedRoute = popup.getAttribute("data-chatty-page") || "";
        homeContentReady = isHome(popup) && hasLoadedContent(popup);

        /* Arm the correction only if the newly opened popup is actually on a
           stale non-Home route. If Home is already present, there is nothing
           to correct and later user navigation must remain untouched. */
        homeResetPending = !isHome(popup);
        homeResetStartedAt = performance.now();
        openingWatchArmed = !homeContentReady;
        if (openingWatchArmed) watchStuckOpening();
        watchVisibleOpening();
        if (homeResetPending) scheduleHomeResetAttempt(260);
        else scheduleBrokenTrackRecovery();
        return;
      }

      /* Once the real Home body has loaded, the opening watchdog must be
         permanently disarmed. Future transitions belong to the customer,
         even if Help/FAQ data subsequently fails to load. */
      const currentRoute = popup.getAttribute("data-chatty-page") || "";
      if (isHome(popup) && hasLoadedContent(popup)) {
        homeContentReady = true;
        clearEmergencyTimer();
        clearOpeningWatch();
      } else if (homeContentReady && currentRoute !== "homePage" && lastObservedRoute === "homePage") {
        navigationCommitted = true;
        finishHomeReset();
        clearOpeningWatch();
      }
      lastObservedRoute = currentRoute;

      if (homeResetPending && isHome(popup)) {
        finishHomeReset();
        return;
      }

      /* Critical: while the popup is already open, normal navigation through
         Help / FAQ / article pages is intentional user navigation. Never arm
         a Home reset from those route mutations. Only the closed -> open
         transition above may arm it. */
      if (homeResetPending && mutations.some((mutation) =>
        mutation.type === "childList" ||
        mutation.attributeName === "data-chatty-page" ||
        mutation.attributeName === "class"
      )) {
        scheduleHomeResetAttempt(220);
      } else {
        scheduleBrokenTrackRecovery();
      }
      if (navigationCommitted && !isHome(popup)) {
        if (hasLoadedContent(popup)) clearBlankNavigationTimer();
        else scheduleBlankNavigationRecovery();
      } else if (!navigationCommitted && !hasLoadedContent(popup) && !openingFallbackInserted) {
        watchVisibleOpening();
      }
    });

    popupObserver.observe(popup, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "data-chatty-page"]
    });

    if (wasOpen) {
      resetToken += 1;
      resetAttempts = 0;
      homeResetPending = !isHome(popup);
      homeResetStartedAt = performance.now();
      openingWatchArmed = !homeContentReady;
      if (openingWatchArmed) watchStuckOpening();
      watchVisibleOpening();
      if (homeResetPending) scheduleHomeResetAttempt(260);
      else scheduleBrokenTrackRecovery();
    }
  };

  const findPopup = () => {
    const candidate = document.querySelector(POPUP);
    if (candidate) wirePopup(candidate);
  };

  const boot = () => {
    installStyles();
    document.addEventListener("pointerdown", onLauncherIntent, true);
    document.addEventListener("click", onLauncherIntent, true);
    document.addEventListener("pointerdown", cancelHomeResetOnIntent, true);
    document.addEventListener("touchstart", cancelHomeResetOnIntent, true);
    document.addEventListener("click", cancelHomeResetOnIntent, true);
    document.addEventListener("click", interceptTrackingNavigation, true);
    document.addEventListener("keydown", interceptTrackingKeyboard, true);
    findPopup();
    if (!bodyObserver && document.body) {
      bodyObserver = new MutationObserver((mutations) => {
        if (mutations.some((mutation) =>
          [...mutation.addedNodes].some((node) =>
            node instanceof Element && (node.matches?.(POPUP) || node.querySelector?.(POPUP))
          )
        )) findPopup();
      });
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
})();
